// Vendor libraries
import { CommonModule } from '@angular/common';
// Module Imports
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import * as i0 from "@angular/core";
export class CorrelationMatrixHeatmapModule {
}
CorrelationMatrixHeatmapModule.ɵfac = function CorrelationMatrixHeatmapModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CorrelationMatrixHeatmapModule)(); };
CorrelationMatrixHeatmapModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: CorrelationMatrixHeatmapModule });
CorrelationMatrixHeatmapModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, LoadingSymbolModule] });
